import VueRouter from 'vue-router'
import AuthService from './services/auth'

import store from './store'
// import { ROLES } from '@/utils/constants';

import orders from '@/routes/orders'
import invoices from '@/routes/invoices'
import autolists from '@/routes/autolists'
import users from '@/routes/users'
import customersRequests from '@/routes/customersRequests'
import reports from '@/routes/reports'
import statistics from '@/routes/statistics'
import notifications from '@/routes/notification'
import revisions from '@/routes/revisions'
import clients from '@/routes/clients'
import profile from '@/routes/profile'
import projects from '@/routes/projects'
import cod from '@/routes/cod'
import platform from '@/routes/platform'
import nomenclature from '@/routes/nomenclature'
import stores from '@/routes/stores'
import tablet from '@/routes/tablet'
import runners from '@/routes/runners'
import settings from '@/routes/settings'
import telephony from '@/routes/telephony'
import cards from "@/routes/cards"
import tasks from "@/routes/tasks";
import files from "@/routes/files";

import LayoutLogin from './views/layouts/LayoutLogin.vue'
// Auth
import Login from './views/auth/Login.vue'
import Register from './views/auth/Register.vue'
import NotFoundPage from './views/errors/404.vue'
import filesStorage from "@/routes/filesStorage";
import TabletLogin from "@/views/layouts/TabletLogin.vue";
import regionRoutes from "@/routes/regionRoutes";
import utils from "@/helpers/utilities";
import Ls from "@/services/ls";
import services from "@/routes/services";
import divisions from "@/routes/divisions";
import user from "@/routes/user";

const routes = [
  // cards,
  ...filesStorage,
  ...platform,
  stores,
  tasks,
  ...tablet,
  invoices,
  autolists,
  orders,
  files,
  cards,
  divisions,
  services,
  settings,
  user,
  users,
  customersRequests,
  runners,
  reports,
  revisions,
  ...statistics,
  notifications,
  profile,
  clients,
  ...telephony,
  projects,
  ...nomenclature,
  ...regionRoutes,
  cod,
  {
    path: '/',
    component: LayoutLogin,
    children: [
      {
        path: 'login',
        component: Login,
        name: 'login'
      },
      // {
      //   path: 'register',
      //   component: Register,
      //   name: 'register'
      // }
    ]
  },
  //  DEFAULT ROUTE
  {path: '*', component: NotFoundPage}
]

const router = new VueRouter({
  routes,
  mode: 'history',
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  //  If the next route is requires user to be Logged IN
  //   document.title = to.meta.title
  // router.setLayout(TabletLogin);
  const controller = new AbortController();
  controller.abort()
  // source.cancel('Operation canceled by the user.');

  document.title = 'Management'
  // console.log(to.fullPath, navigator.userAgent);
  if (to.fullPath !== '/errors/browser') {
    // const notAllowedBrowsers = ['YaBrowser', 'Edg', 'Firefox'];
    const notAllowedBrowsers = ['Edg'];
    // console.log('browser check');
    let redirect = false
    notAllowedBrowsers.forEach((b) => {
      if (!redirect && navigator.userAgent.toLocaleLowerCase().includes(b.toLocaleLowerCase())) {
        redirect = true
      }
    })
    if (redirect) {
      // console.log('redirect');
      return next({path: '/errors/browser'})
    }
  }
  if (to.matched.some(m => m.meta.requiresAuth)) {
    return AuthService.check(to?.query?.device).then(data => {
      if (!data.authenticated) {
        //TODO check if domain is region
        // if (screen.width <= 760 && utils.isRegionDomain(window.location.host)) {
        //   console.log('redirect');
        //   return next({path: '/r/a'})
        // }
        // } else {
        return next({path: '/login'})
        // }
      }

      if (data.token) {
        Ls.set('auth.token', data.token)
        Ls.set('api-token', data.api_token)
      }

      // if (data.stores) {
      //   store.dispatch('platform/setStores', data.stores)
      // }
      if (data.storeRelations) {
        store.dispatch('platform/setStoreRelations', data.storeRelations)
      }
      if (data.storeNotificationSettings) {
        store.dispatch('platform/setStoreNotificationSettings', data.storeNotificationSettings)
      }

      if (data.orderStatuses) {
        store.dispatch('orders/setStatusTitles', data.orderStatuses)
      }
      if (data.projects) {
        store.dispatch('platform/setProjects', data.projects)
      }
      if (data.cities) {
        store.dispatch('platform/setCities', data.cities)
      }
      if (data.currencies) {
        store.dispatch('platform/setCurrencies', data.currencies)
      }
      if (data.countries) {
        store.dispatch('platform/setCountries', data.countries)
      }

      if (data.activeNotifications) {
        store.dispatch('platform/setActiveNotifications', {
          notifications: data.activeNotifications,
          bankSMS: data.activeBankSMS,
          activeChatDialogs: data.orderAccess.all?.all ? Object.values(data.activeChatsDialogs).reduce((acc, i) => acc + i, 0) : Object.keys(data.orderAccess || {}).reduce((acc, k) => acc + (data.activeChatsDialogs[k] || 0), 0),
        })
      }

      if (data.platformSettings) {
        store.dispatch("platform/setSettings", {general: data.platformSettings});
      }

      if (data.divisions) {
        store.dispatch('platform/setDivisions', data.divisions)
      }
      if (data.user) {
        store.dispatch('user/setCurrentUser', data.user)
      }
      if (data.phoneNumbers) {
        store.dispatch('user/setPhoneNumbers', {'sipAccounts': data.sipAccounts, 'phoneNumbers': data.phoneNumbers})
      }
      if (data.shifts) {
        store.dispatch('user/setShifts', data.shifts)
      }
      if (data.phoneLines) {
        store.dispatch('platform/setPhoneLines', data.phoneLines)
      }
      if (data.allowedShifts) {
        store.dispatch('user/setAllowedShifts', data.allowedShifts)
      }
      if (data.activeWorkGroups) {
        store.dispatch('user/setActiveWorkGroups', data.activeWorkGroups)
      }
      if (data.userIsFreeToday) {
        store.dispatch('user/setUserIsFreeToday', data.userIsFreeToday)
      }
      if (data.activeWorkGroup) {
        store.dispatch('user/setActiveWorkGroup', data.activeWorkGroup)
      }
      // if (data.storeSendSchedule) {
      //   store.dispatch('platform/setStoreSendSchedule', data.storeSendSchedule.reduce((acc, s) => {
      //     acc[s.object_id] = s.sub_value;
      //     return acc;
      //   }, {}))
      // }

      if (data.role === 'partner' && to.name !== 'Login' && to.name !== 'home') {
        if (to.meta && to.meta.allowedTo && to.meta.allowedTo.includes(data.role)) {
          // return next();
        } else {
          return next({path: '/404'})
        }
      }

      if (to.meta && to.meta.accessName && data.role != 'admin') {
        // console.log(to.meta, data)
        if (!data.permissions.includes(to.meta.accessName)) {
          return next({path: '/404'})
        }
      }

      if (data.roleNames && data.roleNames.includes('agentReSeller')) {

        if (to.name !== 'home') {
          if (to.meta.permission) {
            if (!data.permissions.includes(to.meta.permission)) {
              return next({path: '/'})
            }
          } else {
            return next({path: '/'})
          }
        }

      }
      store.dispatch('user/setDetails', data.userDetails)
      const webSettings = data.userDetails.find((d) => d.alias === 'web_settings')
      if (webSettings) {
        store.dispatch('user/setUserSettings', {webSettings: webSettings.details})
      }
      if (data.dynamicData){
        console.log(data.dynamicData);
        store.dispatch('platform/setDynamicData', data.dynamicData);
      }

      store.dispatch('user/setOrdersCountDetails', data.ordersCountDetails)
      store.dispatch('user/setCurrentUserRoleId', data.role)
      store.dispatch('user/setCurrentUID', data.myUID)
      store.dispatch('user/setCurrentUserRoles', data.roleNames)
      store.dispatch('permissions/setPermissions', data.permissions)
      if (data.updateStore) {
        store.dispatch('permissions/setOrderAccess', data.orderAccess)
        store.dispatch('user/setMyShift', data.myShift)
        store.dispatch('orders/setNewOrdersUnderManagerProgress', data?.dynamicData?.newOrderProgress ?? [])
      }
      store.dispatch('user/setUpdateActiveWorkingShift', true)

      const permissions = data.permissions || store.getters('permissions/permissions');
      const role = data.role || store.getters('user/currentUserRoleId');
      if (role !== 'admin') {
        // console.log(permissions, role, to, to.matched, to.matched.some(m => permissions.includes(m.meta.permission)));
        if (to.meta.permission && to.meta.permission !== true && !(to.matched.some(m => permissions.includes(m.meta.permission)))) {
          console.log('REDIRECT no ACCESS');
          return next({path: '/404'})
          // return next({path: '/'})
        }
      }

      return next()
    })
  }
  return next()
})

export default router
